import { render, staticRenderFns } from "./LichSuQuangCaoList.vue?vue&type=template&id=014a004f"
import script from "./LichSuQuangCaoList.vue?vue&type=script&lang=js"
export * from "./LichSuQuangCaoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports